<template>
  <fa-icon icon="robot" />
</template>
